export default __webpack_public_path__ + "static/media/asiacup-brian.e1e778ea.png";